import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-dialog-container',
    templateUrl: './dialog-container.component.html',
    styleUrls: ['./dialog-container.component.css'],
    standalone: false
})
export class DialogContainerComponent implements OnInit {

  subscriptions: Subscription[] = []

  constructor(
    private dialogRef: MatDialogRef<DialogContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public component: any
  ) { }

  
  @HostListener(`window:keyup.esc`) onKeyUp()
  {
    this.dialogRef.close(`canseled`);
  }

  
  ngOnDestroy(): void
  {
    this.subscriptions.forEach(l_sub => l_sub.unsubscribe())
  }

  
  ngOnInit(): void
  {
    this.subscriptions.push(this.dialogRef.afterClosed().subscribe(
      l_result =>
      {
        console.log(`Dialog result: ${ l_result }`);
      })
    )

  }

}
